<template>
    <div class="form-item">
        <label class="label-caption">Tipo Equipamento</label>
        <select :value="tipoSelecionado" @change="atualizarTipo" class="form-control" v-bind="$attrs">
            <option v-for="tipo in lsTipos" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
        </select>
    </div>
</template>
  
<script>
export default {
    props: {
        ckAddTodos: {type: Boolean, default: false},
        tipoSelecionado: {type: Number, default: null}
    },

    computed: {
        lsTipos() {
            const tipos = [
                { id: 1, descricao: 'MÁQUINA COM OPERADOR' },
                { id: 2, descricao: 'IMPLEMENTO' },
                { id: 3, descricao: 'PROFISSIONAIS' },
                { id: 4, descricao: 'VEÍCULOS' }
            ];
            if (this.ckAddTodos) {
                tipos.unshift({ id: 0, descricao: 'TODOS' });
            }
            return tipos;
        }
    },

    methods: {
        atualizarTipo(event) {
            this.$emit('update:tipoSelecionado', Number(event.target.value));
        }
    }
};
</script>